import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { TiptapDocumentItemFragment } from '../../__generated__/graphql';
import { formatDateOnly } from '../../Formatters';

export const TiptapDocumentInfo: FC<{
  tiptapDocument: TiptapDocumentItemFragment;
  replacedByTiptapDocument?: TiptapDocumentItemFragment;
}> = ({ tiptapDocument, replacedByTiptapDocument }) => {
  const isCurrentDocument = !replacedByTiptapDocument;
  return (
    <Alert severity="info">
      <AlertTitle>{isCurrentDocument ? 'Gjeldende dokument' : 'Utgått dokument'}</AlertTitle>
      {replacedByTiptapDocument ? (
        <Stack spacing={1}>
          <div>
            Dokumentet ble markert som utgått av {replacedByTiptapDocument?.createdBy?.name} {formatDateOnly(replacedByTiptapDocument?.createdAt)}.
          </div>

          {replacedByTiptapDocument?.comment && (
            <div>
              <Typography variant="subtitle2">Kommentar</Typography>
              {replacedByTiptapDocument?.comment}
            </div>
          )}
        </Stack>
      ) : (
        <div>
          Opprettet av {tiptapDocument?.createdBy?.name} {formatDateOnly(tiptapDocument?.createdAt)}
        </div>
      )}
    </Alert>
  );
};
